import React, { useEffect, useState } from 'react';
export function OfferBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const mins = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const secs = (timeLeft % 60).toString().padStart(2, '0');
  return <div className="bg-terracotta text-white py-2 px-4 text-center" data-id="element-228">
      <p className="text-xs md:text-sm font-bold flex items-center justify-center gap-2 tracking-wide whitespace-nowrap" data-id="element-229">
        🔥 70% OFF solo hoy — Oferta termina en{' '}
        <span className="bg-white/20 px-2 py-0.5 rounded font-mono text-sm" data-id="element-230">
          {mins}:{secs}
        </span>
      </p>
    </div>;
}